module.exports = __webpack_public_path__ + "static/media/miraclesmission.fd8845eb.png";